import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackEmptyListingShow } from './tracking';
import { useEmptyListingShowTracking } from '../../../common/hooks/useEmptyListingShowTracking';
import { selectIsDesktopListingVisible } from '../../../common/selectors/desktopListing';
import { selectIsListingPending, selectVisibleListingOffers } from '../../../common/selectors/listingOffers';
import { IApplicationState } from '../../../common/types/redux';
import { ListingDesktopContent } from '../ListingDesktopContent';

interface IListingDesktopContainerProps {
  onOfferMouseEnter?: (realtyId: number) => void;
  onOfferMouseLeave?: (realtyId: number) => void;
}

export const ListingDesktopContainer: React.FC<IListingDesktopContainerProps> = ({
  onOfferMouseEnter,
  onOfferMouseLeave,
}) => {
  const isVisible = useSelector(selectIsDesktopListingVisible);
  const visibleOffers = useSelector(selectVisibleListingOffers);
  const isPending = useSelector(selectIsListingPending);
  const jsonQuery = useSelector((state: IApplicationState) => state.filters.jsonQuery);
  const queryString = useSelector((state: IApplicationState) => state.queryString);

  const onTrack = React.useCallback(() => trackEmptyListingShow({ jsonQuery, queryString }), [jsonQuery, queryString]);

  const onEmptyListingShow = useEmptyListingShowTracking({
    offersLength: visibleOffers.length,
    isActive: isVisible,
    onTrack,
  });

  return (
    <ListingDesktopContent
      isLoading={isPending}
      offers={visibleOffers}
      onOfferMouseEnter={onOfferMouseEnter}
      onOfferMouseLeave={onOfferMouseLeave}
      onEmptyListingShow={onEmptyListingShow}
    />
  );
};

ListingDesktopContainer.displayName = 'ListingDesktopContainer';
